import React from 'react';
import SectionTitle from '../Common/SectionTitle';

// Remove direct imports
// import details1 from '../../../public/assets/img/details-1.png';
// import details2 from '../../../public/assets/img/details-2.png';
// import details3 from '../../../public/assets/img/details-3.png';
// import details4 from '../../../public/assets/img/details-4.png';

// First service item type - image left, content right
const DetailItemImageLeft = ({ image, title, description, listItems, delay, imageAlt }) => {
  return (
    <div className="row gy-4 align-items-center features-item">
      <div className="col-md-5 d-flex align-items-center" data-aos="zoom-out" data-aos-delay={delay || '100'}>
        <img src={`${process.env.PUBLIC_URL}/assets/img/${image}`} className="img-fluid" alt={imageAlt || ""} />
      </div>
      <div className="col-md-7" data-aos="fade-up" data-aos-delay={delay || '100'}>
        <h3>{title}</h3>
        <p className="fst-italic">{description}</p>
        
        {listItems && (
          <ul>
            {listItems.map((item, index) => (
              <li key={index}><i className="bi bi-check"></i> <span>{item}</span></li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

// Second service item type - content left, image right
const DetailItemImageRight = ({ image, title, description, listItems, delay, imageAlt }) => {
  return (
    <div className="row gy-4 align-items-center features-item">
      <div className="col-md-7" data-aos="fade-up" data-aos-delay={delay || '100'}>
        <h3>{title}</h3>
        <p className="fst-italic">{description}</p>
        
        {listItems && (
          <ul>
            {listItems.map((item, index) => (
              <li key={index}><i className="bi bi-check"></i> <span>{item}</span></li>
            ))}
          </ul>
        )}
      </div>
      <div className="col-md-5 d-flex align-items-center" data-aos="zoom-out" data-aos-delay={delay || '100'}>
        <img src={`${process.env.PUBLIC_URL}/assets/img/${image}`} className="img-fluid" alt={imageAlt || ""} />
      </div>
    </div>
  );
};

const Details = () => {
  const details = [
    {
      image: 'details-1.png',
      imageAlt: 'TallyPrime Software',
      title: 'TallyPrime – Smarter Business Accounting, Simplified',
      description: 'TallyPrime is more than just accounting software—it\'s a comprehensive business management platform that enables businesses to streamline financial operations, maintain real-time visibility, and ensure regulatory compliance with ease.',
      listItems: [
        'Manage accounting, inventory, payroll, taxation (including GST), and MIS reporting—all in one interface.',
        'Purchase TallyPrime licenses, renewals, or flexible rentals based on your business scale and need.',
        'Access your accounts on the go with TallyPrime Mobile or securely from anywhere with Tally on AWS cloud hosting.',
        'Perfect for SMEs, enterprises, and consultants needing agile and accurate financial insights.'
      ]
    },
    
    {
      image: 'details-2.png',
      imageAlt: 'DigiCloud Hosting',
      title: 'DigiCloud – Enterprise-Grade Cloud Hosting Solutions',
      description: 'DigiCloud offers fully managed cloud hosting, purpose-built for businesses that require security, scalability, and 24/7 uptime. Whether you\'re running Tally, websites, email, or custom ERP apps, DigiCloud keeps your operations secure and connected.',
      listItems: [
        'Host Tally or your apps on a secure, scalable, and high-speed cloud infrastructure with guaranteed 99.99% uptime.',
        'Enjoy seamless DR (Disaster Recovery), daily backups, and infrastructure resilience for business continuity.',
        'Choose from cloud hosting, dedicated servers, colocation, and managed services—all with 24x7 support.',
        'Trusted by thousands of clients across industries for reliable digital infrastructure.'
      ]
    },
    {
      image: 'details-4.png',
      imageAlt: 'SharePro Software',
      title: 'SharePro – The Backbone of Broking Operations',
      description: 'SharePro is an advanced back-office and operations suite built for stockbrokers, portfolio managers, and NBFCs. With 28+ years of market presence, it offers unmatched functionality across the trade life cycle.',
      listItems: [
        'Comprehensive modules including SharePro Desktop, Connect (browser access), Live RMS, PMS, AIR Mobile App, and API integrations.',
        'Supports depository ops (CDSL/NSDL), eKYC, MTF, DP activities, compliance, and NBFC settlements.',
        'Integrated service ticketing system and document scheduler for digital communication automation.',
        'Used by top broking firms to ensure seamless compliance, reporting, and client servicing.'
      ]
    },
    {
      image: 'details-3.png',
      imageAlt: 'BUSY Software',
      title: 'BUSY – Complete Business Management Made Easy',
      description: 'BUSY is a feature-rich ERP and accounting software tailored for growing Indian businesses. It simplifies financial operations, tax compliance, billing, inventory, and customer/vendor management through automation and insightful reporting.',
      listItems: [
        'Handles everything from invoicing and GST filing to multi-location inventory and balance sheet generation.',
        'Available as full license, renewals, or rentals with seamless upgrades as your business scales.',
        'Experience mobility with BUSY\'s Cloud and Mobile App versions for real-time access and synchronization.',
        'Ideal for traders, distributors, wholesalers, and SMEs needing end-to-end control.'
      ]
    }
  ];

  return (
    <section id="features" className="details section">
      <SectionTitle 
        title="Services" 
        description1="Our" 
        description2="Services" 
      />

      <div className="container">
        {/* First service - Image on left */}
        <DetailItemImageLeft
          image={details[0].image}
          title={details[0].title}
          description={details[0].description}
          listItems={details[0].listItems}
          imageAlt={details[0].imageAlt}
        />
        
        {/* Second service - Image on right */}
        <DetailItemImageRight
          image={details[1].image}
          title={details[1].title}
          description={details[1].description}
          listItems={details[1].listItems}
          imageAlt={details[1].imageAlt}
        />
        
        {/* Third service - Image on left */}
        <DetailItemImageLeft
          image={details[2].image}
          title={details[2].title}
          description={details[2].description}
          listItems={details[2].listItems}
          imageAlt={details[2].imageAlt}
        />
        
        {/* Fourth service - Image on right */}
        <DetailItemImageRight
          image={details[3].image}
          title={details[3].title}
          description={details[3].description}
          listItems={details[3].listItems}
          imageAlt={details[3].imageAlt}
        />
      </div>
    </section>
  );
};

export default Details; 